var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardDealsInvested(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#FFF3EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 31.1992C27.2091 31.1992 29 29.4084 29 27.1992C29 24.9901 27.2091 23.1992 25 23.1992C22.7909 23.1992 21 24.9901 21 27.1992C21 29.4084 22.7909 31.1992 25 31.1992Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4404 27.3003L24.0904 27.9503C24.2804 28.1403 24.5904 28.1403 24.7804 27.9603L26.5604 26.3203",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 35H28.9998C33.0198 35 33.7398 33.39 33.9498 31.43L34.6998 23.43C34.9698 20.99 34.2698 19 29.9998 19H19.9998C15.7298 19 15.0298 20.99 15.2998 23.43L16.0498 31.43C16.2598 33.39 16.9798 35 20.9998 35Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19V18.2C21 16.43 21 15 24.2 15H25.8C29 15 29 16.43 29 18.2V19",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6498 24C32.9198 25.26 30.9998 26.14 29.0098 26.64",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6201 24.2695C17.2901 25.4095 19.1101 26.2195 21.0001 26.6795",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDealsInvested);
export default __webpack_public_path__ + "static/media/dashboard-deals-invested.c86198a0c9404c72191cf6d9101bfbac.svg";
export { ForwardRef as ReactComponent };